import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var CalculatorSVG = function CalculatorSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M26,2H6A2,2,0,0,0,4,4V28a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V4A2,2,0,0,0,26,2ZM11,26H9a1,1,0,0,1,0-2h2a1,1,0,0,1,0,2Zm0-4H9a1,1,0,0,1,0-2h2a1,1,0,0,1,0,2Zm0-4H9a1,1,0,0,1,0-2h2a1,1,0,0,1,0,2Zm6,8H15a1,1,0,0,1,0-2h2a1,1,0,0,1,0,2Zm0-4H15a1,1,0,0,1,0-2h2a1,1,0,0,1,0,2Zm0-4H15a1,1,0,0,1,0-2h2a1,1,0,0,1,0,2Zm6,8H21a1,1,0,0,1,0-2h2a1,1,0,0,1,0,2Zm0-4H21a1,1,0,0,1,0-2h2a1,1,0,0,1,0,2Zm0-4H21a1,1,0,0,1,0-2h2a1,1,0,0,1,0,2Zm1-5.5a.5.5,0,0,1-.5.5H8.5a.5.5,0,0,1-.5-.5v-6A.5.5,0,0,1,8.5,6h15a.5.5,0,0,1,.5.5Z"
  }));
};
CalculatorSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(CalculatorSVG);